import { ValidatorFn, AbstractControl } from "@angular/forms";
/**
 * Custom Pattern validator that will test against a regex pattern but also return a passed in error message.
 * @param pattern regex to text this date against
 */
export function EvoPatternValidator(pattern: string | RegExp, message:string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control && control.value) {
            let reg: RegExp = new RegExp(pattern);
            const InvalidPattern = reg.test(control.value);
            return !InvalidPattern ? { 'InvalidPattern': { value: control.value, ErrorMessage: message } } : null;
        }
        return null;
    };
}